import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import countryNameMessages from '../../../../components/country-names.messages';

import style from '../common.module.less';

const isCountryFilter = (selectedFilterBy) => selectedFilterBy?.id === 'returnsCountry';

const getCountryLocalizedName = (countryCode) => {
  const countryMessage = countryNameMessages[countryCode];
  if (!countryMessage) {
    return '';
  }
  return <FormattedMessage {...countryMessage} />;
};

const getOptionDisplayName = (option, selectedFilterBy) => {
  if (isCountryFilter(selectedFilterBy)) {
    return getCountryLocalizedName(option?.value);
  }
  return option ? option.displayName : '';
};

export const FormIsOptions = (criterionStateMethods, criterionArgumentOptions, selectedFilterBy) => {
  const { getCriterionArgument, updateCriterionArgument } = criterionStateMethods;
  const selectedCriterionArgument = getCriterionArgument();
  const selectedCriterionLabel = getOptionDisplayName(selectedCriterionArgument, selectedFilterBy);

  return (
    <div className={style['form-criteria-section']}>
      <DropdownMenu className={style['filter-dropdown-button']} dropdownMenuShouldHaveWidthOfButton>
        <DropdownMenuToggler>{selectedCriterionLabel}</DropdownMenuToggler>
        {criterionArgumentOptions.map((option) => {
          const optionDisplayName = getOptionDisplayName(option, selectedFilterBy);
          return (
            <DropdownMenuItem
              key={`${option.id}-${option.value}`}
              onClick={() => updateCriterionArgument(option)}
              selected={option?.value === selectedCriterionArgument?.value}
            >
              {optionDisplayName}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenu>
    </div>
  );
};
